import { parse, isValid, format, differenceInCalendarDays } from "date-fns";
import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

export type StockDateInfo =
  | { hasDate: false }
  | {
      hasDate: true;
      date: Date;
      daysUntil: number;
      isPastOrToday: boolean;
      isWithinNext30: boolean;
    };

const OSLO_TZ = "Europe/Oslo";

function startOfTodayOsloUtc(now: Date = new Date()): Date {
  const ymd = formatInTimeZone(now, OSLO_TZ, "yyyy-MM-dd");
  return fromZonedTime(`${ymd}T00:00:00`, OSLO_TZ);
}

function midnightOfDateInOsloUtc(date: Date): Date {
  const ymd = format(date, "yyyy-MM-dd");
  return fromZonedTime(`${ymd}T00:00:00`, OSLO_TZ);
}

export function getStockDateInfo(publicationDate?: string): StockDateInfo {
  if (!publicationDate) return { hasDate: false };

  const parsed = parse(publicationDate, "yyyy-MM-dd", new Date());
  if (!isValid(parsed) || format(parsed, "yyyy-MM-dd") !== publicationDate) {
    return { hasDate: false };
  }

  const todayStartUtc = startOfTodayOsloUtc();
  const targetStartUtc = midnightOfDateInOsloUtc(parsed);

  const rawDays = differenceInCalendarDays(targetStartUtc, todayStartUtc);
  const daysUntil = rawDays + 1;

  return {
    hasDate: true,
    date: parsed,
    daysUntil,
    isPastOrToday: rawDays <= 0,
    isWithinNext30: rawDays >= 0 && rawDays <= 30,
  };
}
